import pino, { LoggerOptions } from 'pino';
import { logLevel, nodeEnv } from '@algoan/dashboard/env';

const datadogConfig: LoggerOptions = {
  transport: {
    target: 'pino-pretty',
    options: {
      destination: 1, // Use 1 for stdout (or 2 for stderr for errors)
      colorize: true,
      ignore: 'pid,hostname', // Remove default fields that can conflict with Datadog tags
      translateTime: true,
    },
  },
  level: logLevel || 'info',
  // Ensure logs are in JSON format for the Datadog agent
  formatters: {
    level: (label) => ({ level: label }),
  },
};

// In production, ensure you are logging raw JSON without pino-pretty's formatting
if (nodeEnv === 'production') {
  delete datadogConfig.transport;
}

export const serverLogger = pino(datadogConfig);
